import React from 'react';
import { Text } from 'library';
import { Grid } from '@mui/material';

export function TitleDescription({ title, description }: { title: string; description: string }) {
    return (
        <Grid item container direction="column" style={{ width: 'unset' }}>
            <Text variant="caption" bold>
                {title}{' '}
            </Text>
            <Text variant="caption">{description}</Text>
        </Grid>
    );
}
